export default __webpack_public_path__ + "38d59367a566efe0a3699c19ef9e20d3.png";